import { Typography } from "@packages/ds";
import styled, { css as styledCSS } from "styled-components";

import { breakpoints, semiBoldAlias } from "Libs/theme";

export const Name = styled(Typography.BodyText)``;

export const Value = styled.div`
  line-height: 16px;
  overflow: hidden;
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  color: var(--label-slate-color, var(--slate));
`;

export const Info = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex: 1;
  gap: 16px;
  align-items: center;
  overflow: hidden;
  border-radius: 4px;
  padding: 19px 24px;
  margin-bottom: 8px;
  cursor: pointer;

  background-color: var(--section-snow-background-color, var(--snow));

  > * {
    width: 24%;
    overflow-x: hidden;
  }

  ${props =>
    props.disabled &&
    styledCSS`
      ${Name}, ${Value} {
        color: var(--section-granite-color,var(--granite));
      }
    `};

  :hover {
    box-shadow: 0px 4px 8px
      var(--section-granite-shadow-box-shadow-color, var(--granite-shadow));
  }
`;

export const Truncate = styled.div`
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
`;

const Badge = styled.div`
  margin: 4px 0 0 16px;
  padding: 0 8px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 24px;
  ${semiBoldAlias()};
`;

export const Badges = styled.div`
  display: none;
  justify-content: flex-end;
  overflow-y: hidden;

  ${Badge} {
    margin: 0px;
  }

  @media (min-width: ${breakpoints[2]}) {
    display: flex;
  }
`;

export const Inherited = styled(Badge)`
  background-color: var(--section-slate-background-color, var(--slate));
  color: var(--section-snow-color, var(--snow));
`;

export const Overriding = styled(Badge)`
  background-color: var(
    --section-lemon-chiffon-background-color,
    var(--lemon-chiffon)
  );
  color: var(--section-old-gold-color, var(--old-gold));
`;

export const Inactive = styled(Badge)`
  background-color: var(
    --section-color-neutral-300-background-color,
    var(--color-neutral-300)
  );
  color: var(--section-periwinkle-grey-color, var(--periwinkle-grey));
`;

export const Disabled = styled(Inactive)``;
